<template>
    <div class="flex flex-col">
        <base-notifications ref="notifications" elevated dismissible small/>

        <div v-if="phoneEnabled" class="grid grid-cols-2 mb-2">
            <base-radio-input-button
                v-model="invitationType"
                small
                value="phone"
                name="selectButton">
                {{ trans.get('sponsorship.by_phone') }}
            </base-radio-input-button>
            <base-radio-input-button
                v-model="invitationType"
                small
                value="email"
                name="selectButton">
                {{ trans.get('sponsorship.by_email') }}
            </base-radio-input-button>
        </div>

        <template v-if="invitationType === 'email' || !phoneEnabled">
            <form @submit.prevent="sendEmails" class="py-0">
                <base-text-input v-for="i in email.values.keys()"
                                 v-model="email.values[i]"
                                 :key="i"
                                 :label="trans.get('generic.email')"
                                 :placeholder="trans.get('generic.email')"
                                 @input="email.errors[i] = ''"
                                 :error="email.errors[i]"
                                 class="pb-3"
                                 type="email"
                                 outlined
                                 autocomplete="off"
                >
                    <template #icon>
                        <font-awesome-icon :icon="['fal', 'envelope']"/>
                    </template>
                </base-text-input>
                <base-button link color="dark" font-normal normal-case class="mx-auto my-2 underline"
                             :disabled="!canAddEmailInput" @click="addEmailInput">
                    {{ this.trans.get('sponsorship.add_sponsored') }}
                </base-button>
                <base-button type="submit" :loading="loading" block class="mt-5">
                    {{ trans.get('sponsorship.send_invitation') }}
                </base-button>
            </form>
        </template>

        <template v-else>
            <form @submit.prevent="sendPhones" class="py-0">
                <base-phone-input v-for="i in phone.values.keys()"
                                  v-model="phone.values[i]"
                                  :error="phone.errors[i]"
                                  :key="i"
                                  :only-countries="config.get('sms.phone_number_available_countries')"
                                  :initial-country="config.get('sms.default_phone_number_country_code')"
                                  :label="trans.get('generic.phone')"
                                  :placeholder="trans.get('generic.phone')"
                                  class="pb-3"
                                  outlined
                                  autocomplete="off">
                </base-phone-input>

                <base-button link color="dark" class="mx-auto my-2 underline"
                             font-normal normal-case
                             :disabled="!canAddPhoneInput"
                             @click="addPhoneInput">
                    {{ this.trans.get('sponsorship.add_sponsored') }}
                </base-button>
                <base-button type="submit" :loading="loading" block class="mt-5">
                    {{ trans.get('sponsorship.send_invitation') }}
                </base-button>
            </form>
        </template>
    </div>
</template>

<script>
import BaseAlert from "../elements/BaseAlert";
import BaseButton from "../elements/BaseButton";
import BasePhoneInput from "../elements/BasePhoneInput.vue";
import BaseRadioInputButton from "../elements/custom/BaseRadioInputButton.vue";
import axios from "axios";
import {ziggy_route} from "../ZiggyMixin";
import BaseNotifications from "../elements/BaseNotifications.vue";
import ValidationLang from "../ValidationLang";

export default {
    name: "sponsorship-invitation",
    components: {BaseNotifications, BasePhoneInput, BaseRadioInputButton, BaseAlert, BaseButton},
    props: {
        phoneEnabled: Boolean,
    },
    methods: {
        addEmailInput() {
            if (this.canAddEmailInput) {
                this.email.values.push('');
                this.email.errors.push('');
            }
        },
        addPhoneInput() {
            if (this.canAddPhoneInput) {
                this.phone.values.push('');
                this.phone.errors.push('');
            }
        },
        sendEmails() {
            if (this.email.values.filter(email => email !== '').length > 0) {
                this.loading = true;

                axios.post(ziggy_route('master.account.sponsorship.send.email'), {mails: this.email.values}).then(response => {
                    this.loading = false;

                    if (response.data.message === 'envoye') {
                        this.$refs.notifications.success(this.trans.get('sponsorship.sponsor_sent'));
                        setTimeout(() => {
                            location.reload();
                        }, 1000);
                    } else if (response.data.message === 'mail_errors') {
                        const email_errors = Object.values(response.data.mail_error);
                        email_errors.forEach(email_error => {
                            const key = this.email.values.findIndex(email => email === email_error);
                            Vue.set(this.email.errors, key, this.trans.get('errors.sponsorship.invalid_email'));
                        });
                    }
                }).catch(() => {
                    this.$refs.notifications.error(this.trans.get('generic.an_error_has_occurred'));
                    this.loading = false;
                });
            } else {
                this.$refs.notifications.warning(this.trans.get('sponsorship.empty_input'));
            }
        },
        sendPhones() {
            if (this.phone.values.filter(phone => phone !== '').length > 0) {
                this.loading = true;

                axios.post(ziggy_route('master.account.sponsorship.send.phone'), {phones: this.phone.values.filter(phone => phone !== '')}).then(response => {
                    this.$refs.notifications.success(this.trans.get('sponsorship.sponsor_sent'));
                    setTimeout(() => {
                        location.reload();
                    }, 1000);
                }).catch((errorResponse) => {
                    let errors = errorResponse.response.data.errors;
                    let validationLang = new ValidationLang();
                    let validationErrorsMap = validationLang.getMessageTranslated(errors);

                    for (let key in this.phone.errors) {
                        this.phone.errors[key] = validationErrorsMap.get('phones.' + key) ? validationErrorsMap.get('phones.' + key).join('<br/>') : '';
                    }

                    this.$refs.notifications.danger(this.trans.get('generic.an_error_has_occurred'));
                }).then(() => {
                    this.loading = false;
                });
            } else {
                this.$refs.notifications.warning(this.trans.get('sponsorship.empty_phone_input'));
            }
        },
    },
    computed: {
        canAddEmailInput() {
            return !this.email.values.includes('');
        },
        canAddPhoneInput() {
            return !this.phone.values.includes('');
        }
    },
    data() {
        return {
            invitationType: 'email',
            email: {
                values: ['', '', ''],
                errors: ['', '', ''],
            },
            phone: {
                values: ['', '', ''],
                errors: ['', '', ''],
            },
            loading: false,
        }
    },
}
</script>
